import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';

import {UserInfosFormGeneratorService} from "../../../../formulaires/user/user-infos-form-generator.service";
import {DynamicFormComponent} from "../../../../components/common/dynamic-form/dynamic-form.component";
import { FieldDefinition } from 'src/app/model/field-definition';
import { QuestionControlService } from 'src/app/components/common/fields/question-control.service';

@Component({
    selector: 'app-user-infos-form',
    imports: [
    DynamicFormComponent
],
    templateUrl: './user-infos-form.component.html',
    styleUrls: ['./user-infos-form.component.css']
})
export class UserInfosFormComponent implements OnInit {

  @Input() parentForm!: UntypedFormGroup;
  @Input() formName: string;
  @Input() onlyRgpd = false;

  questions: FieldDefinition<any>[];
  form: any;

  constructor(private userInfosFormGeneratorService: UserInfosFormGeneratorService, private qcs: QuestionControlService) {
  }

  ngOnInit(): void {
    this.userInfosFormGeneratorService.getQuestions(this.onlyRgpd).subscribe(q => {
      this.questions = q;
      if (this.parentForm.contains(this.formName)) {
        this.form = this.parentForm.controls[this.formName];
      } else {
        this.form = this.qcs.toFormGroup(this.questions, () => {
        });
        this.parentForm.setControl(this.formName, this.form);
      }
    });
  }
}
